export const colunas = [
  {
    title: '#',
    dataIndex: 'ProdutoId',
    key: 'ProdutoId',
    width: 76
  },
  {
    title: 'Nome',
    dataIndex: 'Nome',
    key: 'Nome'
  },
  {
    title: 'CodigoABS',
    dataIndex: 'CodigoFornecedor',
    key: 'CodigoFornecedor'
  },
  {
    title: 'Raça',
    dataIndex: 'TouroRaca',
    key: 'TouroRaca'
  },
  {
    title: 'Rack',
    dataIndex: 'TouroRack',
    key: 'TouroRack'
  },
  {
    title: 'Tipo Semen',
    dataIndex: 'TouroSemenTipo',
    key: 'TouroSemenTipo'
  },
  {
    title: 'Produto Tipo',
    dataIndex: 'ProdutoTipoNome',
    key: 'ProdutoTipoNome'
  }
]